import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { injectModels } from "../redux/injectModels";
import { toast } from "react-toastify";
import { AuthService } from "../services";
import { useDispatch } from "react-redux";
import * as CONSTANTS from "../redux/Models/Application/constants";
import HeaderLogo from "../components/Logo/HeaderLogo";
import { handleConsoleError } from "../utils/common-methods";
import { globalConstant } from "../constants/globalConstant";

function ForgotPassword(props) {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  //const [emailError, setEmailError] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleEmailChange = (e) => {
    e.preventDefault();
    const val = e.target.value.trim();
    if (val === "") {
      setError("Email is required");
    } else if (!globalConstant.emailRegex.test(val)) {
      setError("Please enter a valid email address.");
    } else {
      setError("");
    }

    setEmail(val);
  };

  const handleSubmit = (e) => {
      e.preventDefault();
    props.application.setLoading(true, "Please wait!");
    let valid = true;
    if (email.trim() === "") {
      setError("Email is required");
      valid = false;
    } else if (!globalConstant.emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      valid = false;
    } else {
      setError("");
    }
    if (!valid) {
      props.application.setLoading(false, "Please wait!");    
      return;
    } else {
      setError("");
      AuthService.ForgotPassword({ email: email })
        .then((response) => {
          props.application.setLoading(false, "Please wait!");
          if (response?.isSuccess) {
            toast.success("Email has been sent successfully");
            dispatch({
              type: CONSTANTS.SET_CURRENT_MODAL,
              payload: CONSTANTS.CLEAR_MODAL,
            });
            navigate("/");
          } else {
            setError(response?.message ||response?.Errors?.[0]?.Message);
            toast.error(response?.message ||response?.Errors?.[0]?.Message || "Something went wrong");
          }
        })
        .catch((error) => {
          props.application.setLoading(false, "Please wait!");
          const message = handleConsoleError(error);
          setError(error?.message || message);
          setSuccessMessage("");
          toast.error(error?.message || message);
        });
    }
  };

  const toggleLogin = () => {
    dispatch({
      type: CONSTANTS.SET_CURRENT_MODAL,
      payload: CONSTANTS.LOGIN_MODAL,
    });
  };

  return (
    <React.Fragment>
      <section className="loginswallow">
        <div className="form-container" id="form-container">
          <form id="login-form" onSubmit={handleSubmit}>
            <HeaderLogo></HeaderLogo>
            <h3>Forgot Password</h3>
            <label htmlFor="username">Email</label>
            <input
              type="text"
              placeholder="Enter Email"
              id="login-username"
              autoComplete="off"
              value={email}
              onChange={handleEmailChange}
            />

            {successMessage && (
              <p className="alert alert-successr">{successMessage}</p>
            )}
            {error && <p className="text-danger">{error}</p>}
            <button type="submit">Send password reset link</button>

            <p className="signup-text">
              Back to{" "}
              <a href="#!" onClick={() => toggleLogin()}>
                Log In
              </a>
            </p>
          </form>
        </div>
      </section>
    </React.Fragment>
  );
}
export default injectModels(["application"])(ForgotPassword);
